module.exports = __webpack_public_path__ + "media/images/flags/sa-0473f0624ff114f7cc735dcbb1056237.svg";